__turbopack_context__.v({
  "contactAside": "legal-module__Yd4PWa__contactAside",
  "emptyState": "legal-module__Yd4PWa__emptyState",
  "eyebrow": "legal-module__Yd4PWa__eyebrow",
  "faqItem": "legal-module__Yd4PWa__faqItem",
  "faqList": "legal-module__Yd4PWa__faqList",
  "faqMeta": "legal-module__Yd4PWa__faqMeta",
  "faqTag": "legal-module__Yd4PWa__faqTag",
  "field": "legal-module__Yd4PWa__field",
  "fieldHint": "legal-module__Yd4PWa__fieldHint",
  "formCard": "legal-module__Yd4PWa__formCard",
  "formLayout": "legal-module__Yd4PWa__formLayout",
  "formStack": "legal-module__Yd4PWa__formStack",
  "grid": "legal-module__Yd4PWa__grid",
  "hero": "legal-module__Yd4PWa__hero",
  "heroAside": "legal-module__Yd4PWa__heroAside",
  "heroCard": "legal-module__Yd4PWa__heroCard",
  "heroText": "legal-module__Yd4PWa__heroText",
  "heroTitle": "legal-module__Yd4PWa__heroTitle",
  "input": "legal-module__Yd4PWa__input",
  "metaCard": "legal-module__Yd4PWa__metaCard",
  "noteCard": "legal-module__Yd4PWa__noteCard",
  "page": "legal-module__Yd4PWa__page",
  "panel": "legal-module__Yd4PWa__panel",
  "searchIcon": "legal-module__Yd4PWa__searchIcon",
  "searchInput": "legal-module__Yd4PWa__searchInput",
  "searchWrap": "legal-module__Yd4PWa__searchWrap",
  "section": "legal-module__Yd4PWa__section",
  "sectionTitle": "legal-module__Yd4PWa__sectionTitle",
  "shell": "legal-module__Yd4PWa__shell",
  "stack": "legal-module__Yd4PWa__stack",
  "status": "legal-module__Yd4PWa__status",
  "statusError": "legal-module__Yd4PWa__statusError",
  "statusSuccess": "legal-module__Yd4PWa__statusSuccess",
  "submitButton": "legal-module__Yd4PWa__submitButton",
  "submitRow": "legal-module__Yd4PWa__submitRow",
  "textarea": "legal-module__Yd4PWa__textarea",
  "toggleButton": "legal-module__Yd4PWa__toggleButton",
  "toggleButtonActive": "legal-module__Yd4PWa__toggleButtonActive",
  "toggleGroup": "legal-module__Yd4PWa__toggleGroup",
});
